import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import * as Actions from './store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import _ from 'lodash';

const styles = theme => ({
    layoutRoot: {},
});

class StudentEventList extends Component {

    constructor(props) {
        super(props);
        this.props.getEventList(props.auth.user.data.role_info.link_id);
    }

    trimUnscheduledTime = (time, unscheduled) => {
        if (unscheduled) {
            return moment(time).format('MMM Do, YYYY')
        }
        return moment(time).format('MMM Do YYYY, hh:mm A')
    }

    getLinkOrGrade = (accessor) => {
        return (
            <div className="flex items-center">
                <IconButton
                    style={{ paddingBottom: '0px', paddingTop: '0px' }}
                    onClick={(ev) => {
                        ev.stopPropagation();
                        this.props.history.push(`/${accessor.EventType.toLowerCase()}/student/${accessor.company_calendar_event_id}`)
                    }}
                >
                    <Icon>edit</Icon>
                </IconButton>
            </div>
        )
    }

    getGradeRow = (accessor) => {
        if (accessor.IsGraded) {
            return (
                accessor.score
            )
        }
        else if (accessor.SubmissionDate && !accessor.IsGraded) {
            return (
                'Submitted'
            )
        }
        else {
            return (
                'Incomplete'
            )
        } 
    }

    render() {
        const { classes, eventList, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        const table_name = this.constructor.name;

        if (!is_loaded) return <React.Fragment>Loading...</React.Fragment>;

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <div className="p-24"><h4>Event List</h4></div>
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">

                    </div>
                }
                content={
                    <ReactTable
                        columns={[
                            {
                                Header: "Event",
                                accessor: "EventName"
                            },
                            {
                                Header: "Course",
                                accessor: "CourseName",
                            },
                            {
                                Header: "Lesson",
                                accessor: "LessonName",
                            },
                            {
                                Header: "Event Type",
                                accessor: "EventType",
                            },
                            {
                                Header: "Start Time",
                                accessor: a => this.trimUnscheduledTime(a.StartTime, a.unscheduled),
                                sortMethod: (a, b) => {
                                    return moment(a, 'MMM Do YYYY, hh:mm A') > moment(b, 'MMM Do YYYY, hh:mm A') ? 1 : -1;
                                },
                                id: "StartTime"
                            },
                            {
                                Header: "End Time",
                                accessor: a => this.trimUnscheduledTime(a.EndTime, a.unscheduled),
                                sortMethod: (a, b) => {
                                    return moment(a, 'MMM Do YYYY, hh:mm A') > moment(b, 'MMM Do YYYY, hh:mm A') ? 1 : -1;
                                },
                                id: "EndTime"
                            },
                            {
                                Header: "Unscheduled",
                                accessor: a => a.unscheduled ? 'Yes' : 'No',
                                id: "Unscheduled"
                            },
                            {
                                Header: 'Grade Status',
                                accessor: a => a.EventStatus,
                                id: 'grade'
                            },
                            {
                                Header: '',
                                accessor: a => this.getLinkOrGrade(a),
                                id: 'click',
                                filterable: false
                            }

                        ]}
                        data={eventList}
                        defaultPageSize={25}
                        pageSize={table_page_size[table_name]}
                        className="-striped -highlight"
                        noDataText="No Assignments Found"
                        defaultSorted={table_sort[table_name]}
                        onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                        filterable={true}
                        defaultFiltered={table_filter[table_name]}
                        onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                        onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                    />
                }
            />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getEventList:      Actions.getStudentEventList,
        setTableSort:      TableActions.setTableSort,
        setTableFilter:    TableActions.setTableFilter,
        resetTableFilter:  TableActions.resetTableFilter,
        setTablePageSize:  TableActions.setTablePageSize,
    }, dispatch);
}

function mapStateToProps({ studentApp, tableSort, auth }) {
    return {
        eventList:       studentApp.student_events.eventList,
        table_sort:      tableSort.table_sort,
        table_filter:    tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded:       tableSort.is_loaded,
        auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(StudentEventList)));


// WEBPACK FOOTER //
// src/main/content/student/StudentEventList.js